/**
 * Countries allowed for company creation.
 *
 * Currently restricted to Switzerland. This is temporary — expansion to
 * France (accounting-fr service) is planned. Centralised here so that
 * opening a new market is a single-line change instead of scattered
 * `=== 'CH'` checks across multiple files.
 */
export const ALLOWED_COMPANY_COUNTRIES = ['CH'] as const;
